(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    

jQuery ('.collection-list-section .list-collection-wrapper .list-collections').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  arrows: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
         slidesToShow: 2
      }
    },
    {
      breakpoint: 574,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-new"] && !Shopify.designMode) return;
  try {
    

$('.collection-list-section .list-collection-wrapper .list-collections').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  arrows: true,
  adaptiveHeight: true
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-promotions-new-arrivals"] && !Shopify.designMode) return;
  try {
    

$('.collection-list-section .list-collection-wrapper .list-collections').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  arrows: true,
  adaptiveHeight: true
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-promotions"] && !Shopify.designMode) return;
  try {
    

$('.collection-list-section .list-collection-wrapper .list-collections').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  arrows: true,
  adaptiveHeight: true
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-featured-collections"] && !Shopify.designMode) return;
  try {
    

  $('.collection-list-section .list-collection-wrapper .list-collections').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    arrows: true,
    adaptiveHeight: true
  });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trending-summer-fashions-section"] && !Shopify.designMode) return;
  try {
    

$('.trending-summer-fashions-section .list-collection-wrapper .list-collections-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  arrows: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
         slidesToShow: 2
      }
    },
    {
      breakpoint: 574,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();
})();
